__turbopack_context__.v({
  "block": "maPkYG_block",
  "blockBody": "maPkYG_blockBody",
  "blockBodyLoose": "maPkYG_blockBodyLoose",
  "blockLabel": "maPkYG_blockLabel",
  "blockWithIcon": "maPkYG_blockWithIcon",
  "blocks": "maPkYG_blocks",
  "circleIcon": "maPkYG_circleIcon",
  "contactBody": "maPkYG_contactBody",
  "contactSummary": "maPkYG_contactSummary",
  "contactWhenPrimary": "maPkYG_contactWhenPrimary",
  "footer": "maPkYG_footer",
  "freqCount": "maPkYG_freqCount",
  "freqHeader": "maPkYG_freqHeader",
  "ownerName": "maPkYG_ownerName",
  "root": "maPkYG_root",
  "spin": "maPkYG_spin",
  "updateButton": "maPkYG_updateButton",
  "updateButtonContent": "maPkYG_updateButtonContent",
  "updateButtonSpinner": "maPkYG_updateButtonSpinner",
});
